import { createContext, useState } from 'react'

import { sdk } from '../../services/sdk'

interface ProvidersDataContext {
  loading: boolean
  checkboxRisksFilter: boolean
  activeProviders: number
  inactiveProviders: number
  providersCount: number
  riskProviders: number
  providersWithInvoices: number

  actions: {
    setCheckboxRisksFilter: (value: boolean) => void
    getProvidersStatistics: () => Promise<void>
  }
}

interface ProvidersProviderProps {
  children: React.ReactNode
}

export const ProvidersContext = createContext({} as ProvidersDataContext)

export function ProvidersProvider(props: ProvidersProviderProps) {
  const [loading] = useState(false)
  const [checkboxRisksFilter, setCheckboxRisksFilter] = useState(false)

  const [activeProviders, setActiveProviders] = useState(0)
  const [inactiveProviders, setInactiveProviders] = useState(0)
  const [providersWithInvoices, setProvidersWithInvoices] = useState(0)
  const [providersCount, setProvidersCount] = useState(0)
  const [riskProviders, setRiskProviders] = useState(0)

  const getProvidersStatistics = async () => {
    try {
      const _response = await sdk.traceability.companiesStatistics()
      setActiveProviders(_response.providerCompaniesActiveQuantitySum.value)
      setInactiveProviders(_response.providerCompaniesInactiveQuantitySum.value)
      setProvidersCount(_response.providerCompaniesQuantitySum.value)
      setRiskProviders(
        _response.providerCompaniesWithSocialEnvironmentalRiskQuantitySum.value,
      )
      setProvidersWithInvoices(
        _response.providerCompaniesWithInvoicesQuantitySum.value,
      )
    } catch (error) {
      console.error(error)
    }
  }

  return (
    <ProvidersContext.Provider
      value={{
        loading,
        checkboxRisksFilter,
        activeProviders,
        inactiveProviders,
        providersCount,
        riskProviders,
        providersWithInvoices,
        actions: {
          setCheckboxRisksFilter,
          getProvidersStatistics,
        },
      }}
    >
      {props.children}
    </ProvidersContext.Provider>
  )
}
